import { createId } from '@paralleldrive/cuid2';

import {
  ActionButtonsBlock,
  ActionInputFormBlock,
  ActionInputs,
  ActionInput,
  AnswerBlock,
  MarkdownTextBlock,
  ActionInputsSchema,
} from '../types';

export const markdownTextBlock = ({ text = '' }: { text?: string } = {}): MarkdownTextBlock => ({
  id: createId(),
  type: 'markdown-text',
  text,
});

export const actionInputFormBlock = ({
  actionId,
  initialValues,
  onSubmit,
  inputs,
  schema,
}: {
  actionId: string;
  initialValues: ActionInputs;
  onSubmit: (inputs: ActionInputs) => void;
  inputs: ActionInput[];
  schema: ActionInputsSchema;
}): ActionInputFormBlock => ({
  id: createId(),
  type: 'action-input-form',
  state: 'ready',
  actionId,
  initialValues,
  onSubmit,
  inputs,
  schema,
});

export const actionButtonsBlock = (): ActionButtonsBlock => ({
  id: createId(),
  type: 'action-buttons',
});

export const isMarkdownTextBlock = (block: AnswerBlock): block is MarkdownTextBlock => {
  return block.type === 'markdown-text';
};

export const blocksToPlainText = (blocks: AnswerBlock[]): string =>
  blocks
    .filter(isMarkdownTextBlock)
    .map((block) => block.text)
    .join('\n\n---\n\n');

export const isActionInputFormBlock = (block: AnswerBlock): block is ActionInputFormBlock => {
  return block.type === 'action-input-form';
};

export const isActionButtonsBlock = (block: AnswerBlock): block is ActionButtonsBlock => {
  return block.type === 'action-buttons';
};
